var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSignup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71759 9.66857C11.1113 9.66857 13.0519 7.72805 13.0519 5.33429C13.0519 2.94053 11.1113 1 8.71759 1C6.32383 1 4.3833 2.94053 4.3833 5.33429C4.3833 7.72805 6.32383 9.66857 8.71759 9.66857Z",
    stroke: "#485058",
    strokeWidth: 0.8172
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3114 11.6771H5.01714C2.79714 11.6771 1 13.4743 1 15.6943V18.2314C1 18.8657 1.52857 19.3943 2.16286 19.3943H15.2714C15.9057 19.3943 16.4343 18.8657 16.4343 18.2314V15.6943C16.3286 13.4743 14.5314 11.6771 12.3114 11.6771Z",
    stroke: "#485058",
    strokeWidth: 0.8172
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3284 19.5001C18.1383 19.5001 19.6056 18.0329 19.6056 16.2229C19.6056 14.413 18.1383 12.9458 16.3284 12.9458C14.5185 12.9458 13.0513 14.413 13.0513 16.2229C13.0513 18.0329 14.5185 19.5001 16.3284 19.5001Z",
    fill: "#485058",
    stroke: "#DADADA",
    strokeWidth: 0.91
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8486 16.2229H17.8086",
    stroke: "#DADADA",
    strokeWidth: 0.91,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3286 14.7429V17.7029",
    stroke: "#DADADA",
    strokeWidth: 0.91,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSignup);
export default __webpack_public_path__ + "static/media/ic_signup.8cdb9360e1ee0df0aa72ec355678560c.svg";
export { ForwardRef as ReactComponent };